import { useQuery } from "@tanstack/react-query";
import { language } from "./query";
import { PostModel } from "common/models/BaseModel";
import { ILanguageGridFilter } from "./types";

export function GetLanguages(
  model: PostModel<ILanguageGridFilter> | undefined
) {
  return useQuery(language.list(model));
}

export function GetLanguage(Id?: string | null) {
  return useQuery({
    ...language.getById(Id),
    enabled: Boolean(Id),
  });
}

export function GetLanguageValues() {
  return useQuery({
    ...language.getLanguageValues(),
    refetchOnMount: true,
  });
}

export function GetLanguageView(id: string | null | undefined, isOpen: boolean) {
  return useQuery({
    ...language.getViewById(id),
    enabled: Boolean(id) && isOpen,
  });
}
